"use strict";
angular.module("exploitation")

	.controller("NetworksOrganizationCtrl", ["$scope","toastr", "ExploitationService", function ($scope,toastr, ExploitationService) {


		/**************************************************************************************************************
		 * Configuration / init
		 **************************************************************************************************************/
		$scope.data = {
			networks: {}
		};



		ExploitationService.getNetworks().then((response) => {
			ExploitationService.updateNetworkCache(response.data);
			$scope.data.networks = response.data;
		}).catch((error) => {
			toastr.error(error.data.message, "Erreur récupération réseaux");
		});


		/**
		 * Tronque le texte s'il est trop grand
		 */
		$scope.getTruncatedString = (text) => {
			if(text && text.length > 50) {
				return text.substring(0, 50) + "[...]";
			}
			return text;
		}

		$scope.saveNetworksOrder = function() {
			var i = 0;

			for (i = 0; i < $scope.data.networks.length; i++) {
				let networkPosition = i+1;

				if (networkPosition !== $scope.data.networks[i].position){
					$scope.data.networks[i].position = networkPosition;
					ExploitationService.editNetwork($scope.data.networks[i], false).then(() => {}).catch(function (error) {
						toastr.error(error.data, "Impossible de valider la nouvelle position du réseau " + $scope.data.networks[i].name);
						$scope.data.loading = false;
					});
				}
			}

		};



	}]);
